import ActionTypes from "./ActionTypes";
import InteractionTypes from "./InteractionTypes";

const FeatureType = 'Story Elements';

const StoryElementEventTypes = {
	STORYELEMENTS_TERM_CLICKED: {
		featureClick: {
			name: 'AppealSearch'
		},
		interaction: {
			name: 'Story Element: Term - clicked',
			actionType: ActionTypes.SEARCH,
			interactionType: InteractionTypes.UX_ACTION,
			featureType: FeatureType
		}
	},
	STORYELEMENTS_COVER_CLICKED: {
		featureClick: {
			name: 'AppealsSearchResults'
		},
		interaction: {
			name: 'Story Element: Cover - clicked',
			actionType: ActionTypes.CATALOG_LINK,
			interactionType: InteractionTypes.CALL_TO_ACTION,
			featureType: FeatureType
		}
	},
	STORYELEMENTS_LEARNMORE_CLICKED: {
		featureClick: {
			name: 'LearnAboutStoryElements'
		},
		interaction: {
			name: 'Story Element: Learn More - clicked',
			actionType: ActionTypes.INLINE_DISPLAY,
			interactionType: InteractionTypes.UX_ACTION,
			featureType: FeatureType
		}
	},
	STORYELEMENTS_FINDIT_CLICKED: {
		featureClick: {
			name: 'AppealsSearchResults'
		},
		interaction: {
			name: 'Story Element: Find It - clicked',
			actionType: ActionTypes.CATALOG_LINK,
			interactionType: InteractionTypes.CALL_TO_ACTION,
			featureType: FeatureType
		}
	},
	STORYELEMENTS_TITLE_CLICKED: {
		featureClick: {
			name: 'AppealsSearchResults'
		},
		interaction: {
			name: 'Story Element: Title - clicked',
			actionType: ActionTypes.CATALOG_LINK,
			interactionType: InteractionTypes.CALL_TO_ACTION,
			featureType: FeatureType
		}
	}, STORYELEMENTS_AVAILABILITY_CLICKED: {
		featureClick: {
			name: 'Ots'
		},
		interaction: {
			name: 'Story Element: Availability - clicked',
			actionType: ActionTypes.INLINE_DISPLAY,
			interactionType: InteractionTypes.CALL_TO_ACTION,
			featureType: FeatureType
		}
	}
};

export default StoryElementEventTypes;



// WEBPACK FOOTER //
// ./src/data/types/StoryElementEventTypes.js